import { appConst } from "@/settings";

const workForce = {
    baseApiUrl: appConst.webApiUrl,
    baseClientUrl: appConst.webClientUrl,
    isLoading: false,
    appVersion: '1.0.0',
};

export default workForce;